import { render } from "./compareServices.vue?vue&type=template&id=4ca30ada"
import script from "./compareServices.vue?vue&type=script&lang=js"
export * from "./compareServices.vue?vue&type=script&lang=js"

import "./compareServices.vue?vue&type=style&index=0&id=4ca30ada&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__